import { render, staticRenderFns } from "./CompSubForm.vue?vue&type=template&id=729d7610"
import script from "./CompSubForm.vue?vue&type=script&lang=js"
export * from "./CompSubForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports